import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss']
})
export class UserDialogComponent implements OnInit {

  formUser: FormGroup;
  submiting: boolean = false;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<UserDialogComponent>,
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    const user = JSON.parse(localStorage.getItem('token'));
    const { user: userAccess } = data;

    this.formUser = fb.group({
      id: [null],
      companyId: [user.company_id, Validators.required],
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      password: [null, [Validators.required, Validators.minLength(6)]],
      email: [null, [Validators.required, Validators.email]],
      isAdmin: [false, Validators.required]
    })

    if (userAccess) {
      this.formUser.patchValue({
        id: userAccess.id,
        firstname: userAccess.firstname,
        lastname: userAccess.lastname,
        email: userAccess.email,
        password: userAccess.password,
        isAdmin: userAccess.is_admin == 'true'
      })
    }

  }

  ngOnInit(): void {

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('user') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

  }

  submitUser() {

    const isValid = !this.formUser.invalid;

    if (isValid) {

      const data = this.formUser.getRawValue();
      const request$ = data.id
        ? this.http.save('user:update', data)
        : this.http.save('user', data);

      request$
        .subscribe(
          result => {
            this.dialogRef.close(true);
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

}
